import animationBlue from 'img/nestleLanding/animations/toy/blue.riv';
import animationBlueMobile from 'img/nestleLanding/animations/toy/blue_mobile.riv';
import blueBgBone from 'img/nestleLanding/animations/toy/bone_blue.png';
import blueBgBoneMobile from 'img/nestleLanding/animations/toy/bone_blue_mobile.png';
import greenBgBone from 'img/nestleLanding/animations/toy/bone_green.png';
import greenBgBoneMobile from 'img/nestleLanding/animations/toy/bone_green_mobile.png';
import pinkBgBone from 'img/nestleLanding/animations/toy/bone_pink.png';
import pinkBgBoneMobile from 'img/nestleLanding/animations/toy/bone_pink_mobile.png';
import redBgBone from 'img/nestleLanding/animations/toy/bone_red.png';
import redBgBoneMobile from 'img/nestleLanding/animations/toy/bone_red_mobile.png';
import blueBgBowl from 'img/nestleLanding/animations/toy/bowl_blue.png';
import blueBgBowlMobile from 'img/nestleLanding/animations/toy/bowl_blue_mobile.png';
import greenBgBowl from 'img/nestleLanding/animations/toy/bowl_green.png';
import greenBgBowlMobile from 'img/nestleLanding/animations/toy/bowl_green_mobile.png';
import pinkBgBowl from 'img/nestleLanding/animations/toy/bowl_pink.png';
import pinkBgBowlMobile from 'img/nestleLanding/animations/toy/bowl_pink_mobile.png';
import redBgBowl from 'img/nestleLanding/animations/toy/bowl_red.png';
import redBgBowlMobile from 'img/nestleLanding/animations/toy/bowl_red_mobile.png';
import blueBgCan from 'img/nestleLanding/animations/toy/can_blue.png';
import blueBgCanMobile from 'img/nestleLanding/animations/toy/can_blue_mobile.png';
import greenBgCan from 'img/nestleLanding/animations/toy/can_green.png';
import greenBgCanMobile from 'img/nestleLanding/animations/toy/can_green_mobile.png';
import pinkBgCan from 'img/nestleLanding/animations/toy/can_pink.png';
import pinkBgCanMobile from 'img/nestleLanding/animations/toy/can_pink_mobile.png';
import redBgCan from 'img/nestleLanding/animations/toy/can_red.png';
import redBgCanMobile from 'img/nestleLanding/animations/toy/can_red_mobile.png';
import blueBgDrumstick from 'img/nestleLanding/animations/toy/drumstick_blue.png';
import blueBgDrumstickMobile from 'img/nestleLanding/animations/toy/drumstick_blue_mobile.png';
import greenBgDrumstick from 'img/nestleLanding/animations/toy/drumstick_green.png';
import greenBgDrumstickMobile from 'img/nestleLanding/animations/toy/drumstick_green_mobile.png';
import pinkBgDrumstick from 'img/nestleLanding/animations/toy/drumstick_pink.png';
import pinkBgDrumstickMobile from 'img/nestleLanding/animations/toy/drumstick_pink_mobile.png';
import redBgDrumstick from 'img/nestleLanding/animations/toy/drumstick_red.png';
import redBgDrumstickMobile from 'img/nestleLanding/animations/toy/drumstick_red_mobile.png';
import animationGreen from 'img/nestleLanding/animations/toy/green.riv';
import animationGreenMobile from 'img/nestleLanding/animations/toy/green_mobile.riv';
import blueBgMouse from 'img/nestleLanding/animations/toy/mouse_blue.png';
import blueBgMouseMobile from 'img/nestleLanding/animations/toy/mouse_blue_mobile.png';
import greenBgMouse from 'img/nestleLanding/animations/toy/mouse_green.png';
import greenBgMouseMobile from 'img/nestleLanding/animations/toy/mouse_green_mobile.png';
import pinkBgMouse from 'img/nestleLanding/animations/toy/mouse_pink.png';
import pinkBgMouseMobile from 'img/nestleLanding/animations/toy/mouse_pink_mobile.png';
import redBgMouse from 'img/nestleLanding/animations/toy/mouse_red.png';
import redBgMouseMobile from 'img/nestleLanding/animations/toy/mouse_red_mobile.png';
import blueBgPaw from 'img/nestleLanding/animations/toy/paw_blue.png';
import blueBgPawMobile from 'img/nestleLanding/animations/toy/paw_blue_mobile.png';
import greenBgPaw from 'img/nestleLanding/animations/toy/paw_green.png';
import greenBgPawMobile from 'img/nestleLanding/animations/toy/paw_green_mobile.png';
import pinkBgPaw from 'img/nestleLanding/animations/toy/paw_pink.png';
import pinkBgPawMobile from 'img/nestleLanding/animations/toy/paw_pink_mobile.png';
import redBgPaw from 'img/nestleLanding/animations/toy/paw_red.png';
import redBgPawMobile from 'img/nestleLanding/animations/toy/paw_red_mobile.png';
import animationPink from 'img/nestleLanding/animations/toy/pink.riv';
import animationPinkMobile from 'img/nestleLanding/animations/toy/pink_mobile.riv';
import animationRed from 'img/nestleLanding/animations/toy/red.riv';
import animationRedMobile from 'img/nestleLanding/animations/toy/red_mobile.riv';
import { CardColor } from 'reactApp/sections/Nestle/PetsCard/PetsCard.types';

export const animations = {
    [CardColor.blue]: animationBlue,
    [CardColor.green]: animationGreen,
    [CardColor.red]: animationRed,
    [CardColor.pink]: animationPink,
};

export const animationsMobile = {
    [CardColor.blue]: animationBlueMobile,
    [CardColor.green]: animationGreenMobile,
    [CardColor.red]: animationRedMobile,
    [CardColor.pink]: animationPinkMobile,
};

export const backgroundImages = {
    [CardColor.blue]: {
        bone: blueBgBone,
        paw: blueBgPaw,
        can: blueBgCan,
        mouse: blueBgMouse,
        bowl: blueBgBowl,
        drumstick: blueBgDrumstick,
    },
    [CardColor.green]: {
        bone: greenBgBone,
        paw: greenBgPaw,
        can: greenBgCan,
        mouse: greenBgMouse,
        bowl: greenBgBowl,
        drumstick: greenBgDrumstick,
    },
    [CardColor.red]: {
        bone: redBgBone,
        paw: redBgPaw,
        can: redBgCan,
        mouse: redBgMouse,
        bowl: redBgBowl,
        drumstick: redBgDrumstick,
    },
    [CardColor.pink]: {
        bone: pinkBgBone,
        paw: pinkBgPaw,
        can: pinkBgCan,
        mouse: pinkBgMouse,
        bowl: pinkBgBowl,
        drumstick: pinkBgDrumstick,
    },
};

export const backgroundImagesMobile = {
    [CardColor.blue]: {
        bone: blueBgBoneMobile,
        paw: blueBgPawMobile,
        can: blueBgCanMobile,
        mouse: blueBgMouseMobile,
        bowl: blueBgBowlMobile,
        drumstick: blueBgDrumstickMobile,
    },
    [CardColor.green]: {
        bone: greenBgBoneMobile,
        paw: greenBgPawMobile,
        can: greenBgCanMobile,
        mouse: greenBgMouseMobile,
        bowl: greenBgBowlMobile,
        drumstick: greenBgDrumstickMobile,
    },
    [CardColor.red]: {
        bone: redBgBoneMobile,
        paw: redBgPawMobile,
        can: redBgCanMobile,
        mouse: redBgMouseMobile,
        bowl: redBgBowlMobile,
        drumstick: redBgDrumstickMobile,
    },
    [CardColor.pink]: {
        bone: pinkBgBoneMobile,
        paw: pinkBgPawMobile,
        can: pinkBgCanMobile,
        mouse: pinkBgMouseMobile,
        bowl: pinkBgBowlMobile,
        drumstick: pinkBgDrumstickMobile,
    },
};
